<div class="loading">          
    <div class="effect-3 effects"><img src="assets/images/logo/loading.png" alt="Logo" /></div>
  </div>